import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui-touch-punch';

$.fn.SoundcloudAudio = function() {
  let self = this
  self.player = SC.Widget(self.get(0))
  self.duration = 0
  self.currentTime_ = 0

  self.ready = function(e) {
    self.player.getDuration(function(duration) {
      self.duration = duration / 1000
      self.trigger('loadedmetadata')
    })
  }

  self.play = function(e) {
    self.player.play()
  }

  self.pause = function(e) {
    self.player.pause()
  }

  self.progressed = function(e) {
    self.currentTime_ = e.currentPosition / 1000
    self.trigger('progress')
  }

  self.played = function(e) {
    self.trigger('play')
  }

  self.paused = function(e) {
    self.trigger('pause')
  }

  self.ended = function(e) {
    self.trigger('ended')
  }

  Object.defineProperty(self, 'currentTime', {
    get: function() {
      return self.currentTime_
    },
    set: function(_currentTime) {
      self.currentTime_ = _currentTime
      self.player.seekTo(self.currentTime_ * 1000)
    },
  })

  return function() {
    self.player.bind(SC.Widget.Events.READY, self.ready)
    self.player.bind(SC.Widget.Events.PLAY_PROGRESS, self.progressed)
    self.player.bind(SC.Widget.Events.PLAY, self.played)
    self.player.bind(SC.Widget.Events.PAUSE, self.paused)
    self.player.bind(SC.Widget.Events.FINISH, self.ended)
    return self
  }()
}

$.fn.AudioPlayer = function() {
  let self = this

  if (self.data('audio-player')) {
    return self.data('audio-player')
  }

  self.audio = undefined
  self.is_dragging = false

  self.el = {
    play: self.find('.audio-player__play-btn'),
    pause: self.find('.audio-player__pause-btn'),
    current: self.find('.audio-player__current-time'),
    total: self.find('.audio-player__total-time'),
    bar: self.find('.audio-player__progress-bar'),
    dot: self.find('.audio-player__progress-dot'),
  }

  self.play = function() {
    if (!self.hasClass('audio-player--playing')) {
      self.audio.play()
    }
    self.addClass('audio-player--playing')
  }

  self.pause = function() {
    if (self.hasClass('audio-player--playing')) {
      self.audio.pause()
    }
    self.removeClass('audio-player--playing')
  }

  // self.progress = function(e) {
  //   if (!self.is_dragging) {
  //     self.el.thumb.css('left', (e.relativePosition * 100) + '%')
  //   }
  // }

  // self.finish = function() {
  //   self.removeClass('episode--playing')
  // }

  self.start_drag = function() {
    self.is_dragging = true
  }

  self.stop_drag = function() {
    let percent = parseFloat(self.el.dot.css('left')) / self.el.bar.outerWidth(false),
    second = self.audio.duration * percent
    self.audio.currentTime = second
    self.is_dragging = false
  }

  self.bar_clicked = function(e) {
    let percent = e.originalEvent.offsetX / self.el.bar.outerWidth(false),
    second = self.audio.duration * percent
    self.audio.currentTime = second
  }

  self.loaded = function() {
    let minutes = Math.floor(self.audio.duration / 60),
    seconds = Math.floor(self.audio.duration - (minutes * 60))
    if (seconds < 10) seconds = '0' + seconds
    self.el.total.text(minutes + ':' + seconds)
    self.trigger('loadedmetadata')
  }

  self.progressed = function(e) {
    if (!self.is_dragging) {
      let percentage = self.audio.currentTime / self.audio.duration * 100
      self.el.dot.css('left', percentage + '%')

      let minutes = Math.floor(self.audio.currentTime / 60),
      seconds = Math.floor(self.audio.currentTime - (minutes * 60))
      if (seconds < 10) seconds = '0' + seconds
      self.el.current.text(minutes + ':' + seconds)
    }
  }

  self.played = function(e) {
    self.trigger('play')
  }

  self.paused = function(e) {
    self.trigger('pause')
  }

  self.ended = function(e) {
    self.trigger('ended')
  }

  self.initialize_audio = function() {
    if (self.find('iframe').length) {
      self.audio = self.find('iframe').SoundcloudAudio()
    } else {
      // js audio
    }
    if (self.audio != undefined) {
      self.audio.on('progress', self.progressed)
      self.audio.on('play', self.played)
      self.audio.on('pause', self.paused)
      self.audio.on('ended', self.ended)
      self.audio.on('loadedmetadata', self.loaded)
    }
  }

  return function() {
    self.initialize_audio()
    self.el.play.on('click', self.play)
    self.el.pause.on('click', self.pause)
    self.el.dot.draggable({
			axis: 'horizontal',
			containment: self.el.bar,
			start: self.start_drag,
			stop: self.stop_drag,
		});
    self.el.bar.on('click', self.bar_clicked)
    self.data('audio-player', self)
    return self
  }()
}
